import {
    IS_LOADING_START,
    IS_LOADING_STOP,
   GET_SITE_LIST_SUCCESS,
   
} from "../actions/Types";

const initalState = {
   siteData:[],


}

// login
export const sites = (state = initalState, action) => {
    switch (action.type) {
        case GET_SITE_LIST_SUCCESS:
        
            return {
             ...state,
             ...action.payload
            }
        default:
            return state
    }

}